import {
  BasketItemRequestModel,
  BasketItemResponseModelBase,
  BasketResponseModel,
  RequestModel6,
} from '../../api/data-contracts';
import { WithRequiredProperty } from '../types';

export enum BasketItemType {
  Ctn = 'ctn',
  Product = 'product',
  Service = 'service',
  Tariff = 'tariff',
}

export type ItemPromotionExtraProducts = {
  code?: null | string;
  id: string;
  imageUrl: string;
  itemType: BasketItemType | null;
  kindId: number;
  isB2B: boolean;
  oldPrice?: number;
  price: number;
  productName: string;
  tooltip?: string;
  url?: string;
};

export type BasketItemPromotion = {
  credit: boolean;
  existedSubscriberText: string;
  extraProducts: ItemPromotionExtraProducts[];
  hasDoublePrice: boolean;
  hasRemains: boolean;
  hasRemainsOp: boolean;
  htmlDescription: string;
  id: number;
  isExistedSubscriberPromotion: boolean;
  isOnlyWithPromo: boolean;
  isTariffPromotion: boolean;
  name: string;
  price: number;
  productId: number;
  productPrice: number;
  regionId: number;
  salesNotes: string;
  slug: string;
  tradeIn: boolean;
  tradeInDiscount: null | string;
};

export type BasketItemAdditionalServices = {
  autoProlongation: boolean;
  soc: string;
};

export type ServiceData = {
  period: string;
  periodId: string;
};

export enum SubscriberType {
  Mnp = 'mnp',
  New = 'new',
  Exist = 'exist',
}

export type PromotionTradeIn = {
  Grade: string;
  SKUID: number;
};

export type BasketItemDetails = {
  additionalServices?: BasketItemAdditionalServices[];
  armorJack?: null | string;
  availablePromotion?: BasketItemPromotion | null;
  brandName?: string;
  changeMarketRegion?: boolean;
  changeTariff?: boolean;
  ctn?: null | string;
  ctnHighlighted?: null | string;
  ctnType?: null | string;
  description?: string;
  descriptionSmall?: null | string;
  dpcClient?: number | null;
  familyMaxSimCount?: number;
  familyMinSimCount?: number;
  hasAvailableServices?: boolean;
  hasInsurableClient?: boolean | null;
  hasPassport?: boolean;
  infoChangeTariff?: null | string;
  isAdditional?: boolean | null;
  isCtnTariffReplaced?: boolean;
  isFamily?: boolean;
  isSamplingCompatibleItem?: boolean;
  isSamplingItem?: boolean | null;
  isSamplingItemActive?: boolean | null;
  isSamplingItemParent?: boolean | null;
  mainCollectionId?: number;
  mainCollectionName?: string;
  marketCode?: null | string;
  mustHavePD?: boolean;
  niceClass?: null | string;
  parentCollectionId?: number;
  parentCollectionName?: string;
  presets?: {
    id: number;
    options: string[];
  };
  price?: number;
  promotionCtn?: string;
  promotionId?: null | number;
  promotionTradeIn?: null | PromotionTradeIn;
  regionId?: null | string;
  reserve?: null | string;
  self_registration?: boolean;
  serviceData?: ServiceData | null;
  serviceType?: null | string;
  showPassport?: boolean | null;
  socs?: string[];
  subscriberType?: SubscriberType;
  tooltip?: string;
  variant?: null | string;
};

export interface ExtendedBasketItemResponseModel extends BasketItemResponseModelBase {
  id: string;
  itemId: string;
  children?: ExtendedBasketItemResponseModel[];
  details?: BasketItemDetails;
  itemType?: BasketItemType;
  tariff?: ExtendedBasketItemResponseModel;
  constructorNew?: boolean;
}

/**
 * Расширенная модель корзины
 * Добавлены типы для:
 * details т.к. на бэке для details типа существует
 * itemType т.к. на бэке нет enum, добавляем сами
 * Плюс id и itemId сделаны обязательными
 *
 * Почему так сделано:
 * По-умолчанию модель корзины содержит id и itemId в виде необязательны полей т.к.
 * при получении с фронта запроса на добавление товара itemId не заполнен, на BE модель используется для запросов и ответов одна и та же.
 * рекомендации товаров для добавления в корзину: так как они не являются частью корзины, то и itemId у них нет, а модель та же
 *
 * тип используется для описания ответа тех запросов, которые точно вернут поля id и itemId
 */
export interface ExtendedBasketResponseModel extends BasketResponseModel {
  items?: ExtendedBasketItemResponseModel[];
}

export interface ExtendedBasketItemRequestModel extends BasketItemRequestModel {
  details?: BasketItemDetails;
  itemType?: BasketItemType;
}

export interface ExtendedBasketRequestModel
  extends WithRequiredProperty<Partial<RequestModel6>, 'regionPath'> {
  items?: ExtendedBasketItemRequestModel[];
}
